import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=a8d8ebe4"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports